import { TProductVariant, TSavedProjectsComplimentaryGroup } from 'pages/saved-project-configuration/types';

type TParams = {
  complimentaryGroups: TSavedProjectsComplimentaryGroup[];
  variantProductId: string;
  selectedVariant: TProductVariant;
  groupName: string;
};

export const getUpdatedComplementaryGroups = ({
  complimentaryGroups,
  variantProductId,
  selectedVariant,
  groupName,
}: TParams) =>
  complimentaryGroups.map(group => {
    if (group.groupName === groupName) {
      const products = group.products.map(product =>
        product.code === variantProductId ? { ...product, quantity: selectedVariant.quantity } : product
      );
      return {
        ...group,
        selectedProductId: variantProductId,
        selectedVariantProductId: variantProductId,
        products,
      };
    }
    return group;
  });
